import { render, staticRenderFns } from "./ChatError.vue?vue&type=template&id=451a37bc"
import script from "./ChatError.vue?vue&type=script&lang=js"
export * from "./ChatError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports